module.exports = __webpack_public_path__ + "img/setup.893b4c55.svg";